import { PublicAction } from "../../common/types";
import { ActionComponent } from "./plugin_api";
import { ActionTypeDefinition } from "@flow/common/action_type";
import { bug } from "@flow/lib/error";

type ActionTypeHandler<T_admin, T_public> = {
  def: ActionTypeDefinition<T_admin, T_public>;
  component: ActionComponent<T_public>;
};

const actionComponents: Map<string, ActionTypeHandler<any, any>> = new Map();

export function getActionTypeHandler(action: PublicAction): ActionTypeHandler<any, any> | undefined {
  return actionComponents.get(action.type || bug("passed pure conditional action to getActionTypeHandler"));
}

export function registerActionComponent<T_admin, T_public>(
  def: ActionTypeDefinition<T_admin, T_public>,
  component: ActionComponent<T_public>
): void {
  if (actionComponents.get(def.action_type)) {
    throw new Error(`Attempt to register action component '${def.action_type}', which already exists.`);
  }
  actionComponents.set(def.action_type, { def, component });
}
